import { Component, Inject, Vue } from 'vue-property-decorator';
import Vue2Filters from 'vue2-filters';
import { ExamSession, IExamSession } from '@/shared/model/exam-session.model';
import { ExamType } from '@/shared/model/enumeration/examType.model';
import ExamSessionService from '../../../bo/pages/entities/exam-session/exam-session.service';
import { ExamCenter } from '@/shared/model/exam-center.model';

@Component({
  mixins: [Vue2Filters.mixin],
})
export default class InscriptionPage extends Vue {
  @Inject('examSessionService')
  private examSessionService: () => ExamSessionService;

  public searchDone: boolean = false;
  public sessionsFilteredByCenter = false;
  public showResults: boolean = false;
  public showInscriptionForm: boolean = false;

  //values emitted by child component searchSessionsForm
  public examSessions: IExamSession[] = [];
  public selectedLatitude: number = 0;
  public selectedLongitude: number = 0;
  public selectedPositionName: string = '';
  public selectedExamType: ExamType = ExamType.MARITIME;
  public selectedExamDate: Date = new Date();

  //values emitted by child component sessionCard
  public selectedSession: ExamSession = null;
  public selectedCenter: ExamCenter = null;
  public sessionToRegister: ExamSession = null;

  //computed property : get sessions to display in cards.
  get examSessionsCards(): IExamSession[] {
    if (this.sessionsFilteredByCenter) {
      return this.filterSessionsByCenter(this.examSessions, this.selectedCenter);
    } else {
      return this.examSessions;
    }
  }

  public created() {
    // use of eventHub declare globally in main.ts
    // @ts-ignore
    this.$eventHub.$on('submitSearchSessionsForm', this.retrieveExamSessions);

    // TODO INCREMENT 2 : à retirer pour l'incrément 2
    // @ts-ignore
    this.$eventHub.$on('displayRegistrationForm', this.showRegistrationForm);
  }

  // TODO INCREMENT 2 : à retirer pour l'incrément 2
  public showRegistrationForm() {
    this.showInscriptionForm = true;
  }

  /**
   * Retrieve examSessions emitted by child component SearchSessionsForm
   * @param results examSessions and search criteria
   */
  public retrieveExamSessions(results) {
    this.resetSelectedItems();
    this.searchDone = true;
    this.selectedLatitude = results.selectedLatitude;
    this.selectedLongitude = results.selectedLongitude;
    this.examSessions = results.examSessions;
    this.selectedPositionName = results.selectedPositionName;
    this.selectedExamType = results.selectedExamType;
    this.selectedExamDate = results.selectedExamDate;
    if (this.examSessions.length !== 0) {
      this.showResults = true;
    }
  }

  /**
   * Retrieve the examSession selected by user (emitted by child component sessionCard)
   * @param examSession
   */
  public setSelectedSession(examSession: ExamSession) {
    this.selectedSession = examSession;
  }

  /**
   * Retrieve the examSession to register selected by user (emitted by child component sessionCard)
   * @param examSession
   */
  public setSessionToRegister(examSession: ExamSession) {
    this.sessionToRegister = examSession;
    this.showInscriptionForm = true;
  }

  /**
   * Retrieve the examCenter selected by user (emitted by child component mapSessions)
   * @param examCenter
   */
  public setSelectedCenter(examCenter: ExamCenter) {
    this.sessionsFilteredByCenter = true;
    this.selectedCenter = examCenter;
    this.selectedSession = null;
  }

  /**
   * Filter sessions by examCenter
   * @param examSessions
   * @param examCenter
   */
  public filterSessionsByCenter(examSessions: IExamSession[], examCenter: ExamCenter): IExamSession[] {
    return examSessions.filter(session => session.examCenter.id === examCenter.id);
  }

  /**
   * Reset filter sessions by examCenter
   */
  public resetSelectedItems() {
    this.selectedCenter = null;
    this.selectedSession = null;
    this.sessionsFilteredByCenter = false;
  }
}
